// Description: This file contains the feature constants.

export const FEATURE_CONSTANTS = {
    account: 'Account',
    activity: 'Activity',
    aiSettings: 'AI Settings',
    aiDataImportAssistant: 'Data Import AI Assistant',
    applicationSettings: 'Application Settings',
    assessAvails: 'Assess Avails',
    bookings: 'Bookings',
    catalog: 'Catalog',
    customerEngagement: 'Customer Engagement',
    developerAPI: 'Developer API',
    directoryShare: 'Directory Share',
    discounts: 'Discounts',
    engagementTracker: 'Engagement',
    exchangeRate: 'Exchange Rate',
    fields: 'Fields',
    groupDataSecurity: 'Group Data Security',
    home: 'Home',
    lab: 'Lab',
    leads: 'Leads',
    licensing: 'Licensing',
    listInquiries: 'List inquiries',
    marketplace: 'Marketplace',
    mcpPlayground: 'MCP Playground',
    opportunities: 'Opportunities',
    orders: 'Orders',
    organizationResource: 'Organization Resource',
    organizations: 'Organizations',
    organizationUnits: 'Organization Units',
    people: 'People',
    peopleResources: 'People Resources',
    pipeline: 'Pipeline',
    systemReports: 'System Reports',
    submission: 'Submission',
    production: 'Production',
    productionWorkspace: 'Production Workspace',
    quote: 'Quote',
    quotes: 'Quotes',
    rates: 'Rates',
    report: 'Report',
    reservations: 'Reservations',
    resourceActivityAssignment: 'Resource Activity Assignment',
    resources: 'Resources',
    schedule: 'Schedule',
    schedulerPreview: 'Scheduler Preview',
    security: 'Security',
    shortlist: 'Shortlist',
    upload: 'Upload',
    globalTranslate: 'Global Translate',
    deal: 'Deal',
    dealOperations: 'Deal Operations',
    dealFinancials: 'Deal Financials',
    financials: 'Financials',
    templates: 'Templates',
    orderTemplateManagement: 'Order Template Management'
} as const;
